import { Footer } from "arwes"


const FooterComponent = () => {



    return(
        <div>
            <Footer>

                <div className="pull-left col-lg-4 col-xs-12">
                    <p>Copyright &copy;2022 SCI-FI by Plass</p>
                </div>
            </Footer>
        </div>
    )




}

export default FooterComponent